import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions } from '@epicor/kinetic';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { Location } from '@angular/common';
import { IEpBtCardControlModel, BistrackConfig, BranchAccess } from 'ep-bt-controls';
declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-stock-details',
  templateUrl: './epbt-fa-product-stock-details.component.html',
  styleUrls: ['./epbt-fa-product-stock-details.component.scss']
})
export class EpbtFaProductStockDetailsComponent implements OnInit {

  @ViewChild(EpGridComponent, { static: false }) grid: EpGridComponent;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 10;
  public cards: Array<IEpBtCardControlModel>;

  constructor(public productService: EpbtFaProductService, private location: Location) { }

  ngOnInit() {
    if (!this.productService.selectedStock) {
      this.location.back();
    }
    this.gridModel = this.getGridModel();
  }

  // grid model start
  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'actual',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: this.productService.selectedStock.stockForLength,
      columns: [
        { field: 'length', title: 'LENGTH', width: 80, hidden: false },
        { field: 'stock.actual', title: 'ACTUAL', width: 80, hidden: false },
        { field: 'stock.available', title: 'AVAILABLE', width: 100, hidden: false },
        { field: 'stock.allocated', title: 'ALLOCATED', width: 80, hidden: false },
        { field: 'stock.awaitingProcessing', title: 'AWAITING PROCESSING', width: 100, hidden: false },
        { field: 'stock.onOrder', title: 'ON ORDER', width: 80, hidden: false },
        { field: 'stock.reserved', title: 'RESERVED', width: 100, hidden: false }
      ],
    };
    return model;
  }
  // grid model end

  // grid height calculation start
  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 440; }// return 500;
  }
  // grid height calculation end


}
